import React from 'react';

export class ApprovedRequestsPage extends React.Component<{}> {
    public render() {
        return (
            <div>Approved Requests Page - Coming Soon.</div>
        );
    }
}